import * as z from 'zod';
import { Get as Get$2 } from '../../../../surety/bond/contract/bid-contract-surety-bond.dto.mjs';
import { bidBondAmountTypeSchema, SuretyBondFormType, finalContractSuretyBondFormTypeSchema, dateTimeSchema, bidSuretyBondClosedReasonSchema, ContractSuretyType } from '../../../../../enums.mjs';
import { percentSchema, rateSchema } from '../../../../../types/opaque.mjs';
import { Close as Close$1 } from '../../../../../types/surety/bond/contract/bid-contract-surety-bond.types.mjs';
import { Data } from '../../../../../types/surety/bond/contract/contract-surety-bond.types.mixins.mjs';
import { currencySchema } from '../../../../../types/utils.mjs';
import { Get as Get$4 } from '../../../../sfaa-code/index.mjs';
import { Get as Get$3 } from '../../bond-form/admin-issued-surety-bond-form.dto.mjs';
import { Get as Get$1, Import as Import$1 } from './admin-contract-surety-bond-mixins.dto.mjs';

var Get;
(function (Get) {
    (function (Response) {
        Response.schema = Get$1.Response.baseSchema
            .extend(Get$2.Response.rawSchema.shape)
            .extend({
            bondForm: Get$3.Response.schema,
            sfaaCode: Get$4.Response.schema.nullable(),
        });
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));
var Import;
(function (Import) {
    (function (Request) {
        Request.schema = Import$1.Request.baseSchema.extend({
            contractSuretyType: z.literal(ContractSuretyType.bid),
            bond: Import$1.Request.baseSchema.shape.bond.extend({
                data: z.object({
                    bidAmount: currencySchema,
                    bidDate: dateTimeSchema,
                    finalBondFormType: finalContractSuretyBondFormTypeSchema,
                    finalBondContingentRate: rateSchema,
                    finalBondContingentPremium: currencySchema,
                    closedReason: bidSuretyBondClosedReasonSchema.nullish(),
                    tListingRequired: z.boolean(),
                    isFinalBondCompletionBond: z.boolean(),
                    project: Data.projectSchema.shape.input,
                }),
            }),
            bondForm: Import$1.Request.baseSchema.shape.bondForm.extend({
                data: z.object({
                    bondFormType: z.literal(SuretyBondFormType.bid),
                    bidBondAmountType: bidBondAmountTypeSchema,
                    bondAmountPercentOfBid: percentSchema,
                }),
            }),
        });
    })(Import.Request || (Import.Request = {}));
})(Import || (Import = {}));
var Close;
(function (Close) {
    (function (Request) {
        Request.schema = Close$1.Payload.schema;
    })(Close.Request || (Close.Request = {}));
})(Close || (Close = {}));

export { Close, Get, Import };
